module.exports = {
        srcSet: __webpack_public_path__ + "static/media/movingBoxMobile-166.6efb4746.webp"+" 166w",
        images: [{path: __webpack_public_path__ + "static/media/movingBoxMobile-166.6efb4746.webp",width: 166,height: 166}],
        src: __webpack_public_path__ + "static/media/movingBoxMobile-166.6efb4746.webp",
        toString: function(){return __webpack_public_path__ + "static/media/movingBoxMobile-166.6efb4746.webp"},
        
        width: 166,
        height: 166
      }